export const RESET_UPLOADED_DOCUMENTS =
  'ui:employerBenefits/RESET_UPLOADED_DOCUMENTS';
